<oneclickenroll-app [dialogRef]='dialogRef' [data]='data'></oneclickenroll-app>